import React from "react";

type ButtonProps = {
  text?: string;
  onClick?: () => void;

  variant?: "outline" | "filled";
  rounded?: "full" | "md" | "lg";

  icon?: React.ReactNode;
  iconPosition?: "left" | "right";

  className?: string;        // button
  textClassName?: string;    // text
  iconClassName?: string;
  disabled?: boolean;
  textContainerClassName?: string;
  iconTextClassName?:string
};

const CommonButton: React.FC<ButtonProps> = ({
  text,
  onClick,
  variant = "outline",
  rounded = "full",
  icon,
  iconPosition = "right",
  className = "",
  disabled = false,
  textClassName = "",
  iconClassName = "",
  textContainerClassName = "",
  iconTextClassName = "",
}) => {

  const isIconOnly = icon && !text;

  // BASE STYLE
  const baseStyle = `
  inline-flex items-center justify-center gap-1
  text-[11px] sm:text-[11px] lg:text-sm font-semibold
  transition-all duration-300
  w-fit
  ${disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""}
`;

  const variants = {
    outline: "border border-logoHeading text-logoHeading hover:bg-iconColor hover:text-white hover:border-iconColor",
    filled: "bg-logoHeading text-white hover:bg-iconColor hover:text-white hover:border-iconColor",
  };

  const roundedStyles = {
    full: "rounded-full",
    md: "rounded-md",
    lg: "rounded-lg",
  };

  return (
    <button
      onClick={onClick}
      className={`${baseStyle} ${variants[variant]} ${roundedStyles[rounded]} ${className}`}
      disabled={disabled}
    >
      {/* ICON + TEXT (LEFT) */}
      {icon && iconPosition === "left" && text && (
        <div className={`flex items-center gap-1 ${iconTextClassName || "px-2 py-1"}`}>
          <span className={iconClassName}>{icon}</span>
          <span className={textClassName}>{text}</span>
        </div>
      )}

      {/* ICON + TEXT (RIGHT) */}
      {icon && iconPosition === "right" && text && (
        <div className={`flex items-center gap-1 ${iconTextClassName || "px-2 py-1"}`}>
          <span className={textClassName}>{text}</span>
          <span className={iconClassName}>{icon}</span>
        </div>
      )}

      {/* TEXT ONLY */}
      {!icon && text && (
        <div className={`${textContainerClassName || "px-2 py-2 md:px-3 md:py-2.5"}`}>
          <span className={textClassName}>{text}</span>
        </div>
      )}

      {/* ICON ONLY */}
      {isIconOnly && (
        <div className="p-1">
          <span className={iconClassName}>{icon}</span>
        </div>
      )}
    </button>

  );
};

export default CommonButton;